import { render, staticRenderFns } from "./ProfilePayment.vue?vue&type=template&id=1cd254ab"
import script from "./ProfilePayment.vue?vue&type=script&lang=js"
export * from "./ProfilePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports